module.exports = __webpack_public_path__ + "img/sectionCover2.ff48aafe.png";